import { Page } from '../../common/types';

const PageMap: Record<Page, string> = {
  [Page.Home]: 'home',
  [Page.Category]: 'category',
  [Page.Categories]: 'categories',
  [Page.Article]: 'article',
  [Page.Search]: 'search',
  [Page.Chatbot]: 'chatbot',
};

export const pageEnumToString = (page: Page): string => {
  return PageMap[page];
};